import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { useCurrentPlan } from './useCurrentPlan'
import { useTrialStatus } from './useTrialStatus'

/**
 * Returns true if the user is on Pioneer plan AND currently in trial.
 * Used to gate premium features like Visual Styles and AI Video.
 */
export const useIsPioneerTrial = () => {
  const { data: currentPlan } = useCurrentPlan()
  const { isInTrial } = useTrialStatus()

  const isOnPioneer = currentPlan?.plan === PaymentPlanKey.VirtualMarketer

  return isOnPioneer && isInTrial
}
